/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { SxProps, Theme } from '@mui/material';

export const confirmationDialogContentSX: SxProps = {
	minWidth: { sx: 'unset', md: 600 },
	fontSize: '14px',
};

export const confirmationDialogTitleSX: SxProps<Theme> = {
	fontSize: '18px',
	fontWeight: 800,
	textTransform: 'uppercase',
};

export const confirmationDialogActionsSX: SxProps<Theme> = {
	padding: '16px',
};
